const EventsTagInfo = ({content,title}) =>{
    return(
        <>
            <span className="text-pale9">{title}</span>
            <span className="text-black">{content}</span>
        </>
    )
}

export default EventsTagInfo;